import optionHmonglus from '@/assets/hub/option_hmonglus.png';
import optionMoob from '@/assets/hub/option_moob.png';
import type { Dialect } from '@/providers/LearnerPreferences';

const MODE_ICONS: Record<Dialect, string> = {
  hmonglus: optionHmonglus,
  moob: optionMoob,
};

export function ModeIcon({
  mode,
  size,
  bordered = false,
}: {
  mode: Dialect;
  size: number;
  bordered?: boolean;
}) {
  const image = (
    <img
      src={MODE_ICONS[mode]}
      alt=""
      width={size}
      height={size}
      className="block"
      data-mode-icon={mode}
    />
  );

  if (!bordered) return image;

  return (
    <span
      className="inline-grid place-items-center rounded-full border-2 border-[#399918]"
      style={{ width: size + 4, height: size + 4 }}
    >
      {image}
    </span>
  );
}
